<template>
    <div>
        <Card>
            <Card>
                <p slot="title">{{t.pic.searchName}}</p>
                <Form :model="formItem" :label-width="100" label-position="right">
                    <Row :gutter="16">
                        <Col span="6">
                            <Form-item :label="t.pic.name">
                                <Input v-model="formItem.name"
                                       :placeholder="msgUtil.placeholderRequired(t.pic.name)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.pic.status">
                                <Select v-model="formItem.status" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.pic.status)">
                                    <Option value="1">{{t.pic.open}}</Option>
                                    <Option value="0">{{t.pic.close}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.pic.createStartTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createStartTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.pic.createStartTime)"
                                            :options="createStartTimeOption"
                                            @on-change="onStartTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                        <Col span="6">
                            <Form-item :label="t.pic.createEndTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createEndTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.pic.createEndTime)"
                                            :options="createEndTimeOption"
                                            @on-change="onEndTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <Button type="primary" icon="ios-search" style="float: right;" @click="search(true)">
                                {{msgUtil.message.action.search}}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Row class="margin-top-10">
                <Col span="12">
                    <sort-button-group :buttons="sortButton" @on-order="orderClick"/>
                </Col>
                <Col style="text-align:right;" span="12">
                    <Button icon="md-add" to="./add">{{msgUtil.message.action.add}}</Button>
                    <Button icon="ios-trash" @click="delAll">{{msgUtil.message.action.deleteAll}}</Button>
                </Col>
            </Row>
            <Row class="margin-top-10">
                <Table ref="selection" :context="self" :columns="columns" :data="data" :loading="loading"
                       @on-selection-change="rowSelect"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="end">
                <Page ref="page" :total="total" show-total show-sizer @on-change="pageChange"
                      @on-page-size-change="pageSizeChange">
                    {{msgUtil.message.page.total}} {{ total }} {{msgUtil.message.page.paper}}
                </Page>
            </Row>
        </Card>
        <Modal v-model="visible">
            <img :src="this.clickedIcon" v-if="visible" style="width: 100%">
            <div slot="footer">
            </div>
        </Modal>
    </div>
</template>

<script>
import { Message, Tag } from 'iview';
import { del, delAll, getList } from '@/api/pic';
import sortButtonGroup from '@/components/sort-button-group.vue';

export default {
    name: 'content_pic_list',
    components: {
        sortButtonGroup,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        const renderName = (h, params) => {
            const row = params.row;
            return h('div', [
                h(
                    'router-link',
                    {
                        props: {
                            to: './detail/' + row.id,
                        },
                    },
                    row.name
                ),
            ]);
        };
        const renderSortOrder = (h, params) => {
            const row = params.row;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                    },
                },
                row.sortOrder
            );
        };
        const renderStatus = (h, params) => {
            const row = params.row;
            const color = row.status === '0' ? 'error' : row.status === '1' ? 'success' : 'error';
            const text = row.status === '0' ? t.pic.close : row.status === '1' ? t.pic.open : t.pic.close;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };
        const renderIcon = (h, params) => {
            return h('div', [
                h('img', {
                    style: {
                        'margin-top': '10px',
                        'margin-bottom': '10px',
                        'border-radius': '4px',
                        width: '50px',
                        height: '50px',
                        cursor: 'pointer',
                    },
                    props: {
                        type: 'primary',
                        size: 'small',
                    },
                    attrs: {
                        src: params.row.image,
                        style: 'width: 3px;height: 3px;',
                    },
                    on: {
                        click: e => {
                            this.handleModal(e.srcElement.currentSrc);
                        },
                    },
                }),
            ]);
        };
        const renderAction = (h, params) => {
            const row = params.row;
            return h('button-group', [
                h(
                    'i-button',
                    {
                        props: {
                            type: 'primary',
                            size: 'small',
                            to: './edit/' + row.id,
                        },
                    },
                    msgUtil.message.action.edit
                ),
                h(
                    'i-button',
                    {
                        props: {
                            type: 'error',
                            size: 'small',
                            style: 'margin-left:5px',
                        },
                        on: {
                            click: this.del.bind(this, row.id),
                        },
                    },
                    msgUtil.message.action.delete
                ),
            ]);
        };
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            // 排序btn
            sortButton: [
                { key: 'sortOrder', value: t.pic.sortOrder, order: 0 },
                { key: 'name', value: t.pic.name, order: 0 },
                { key: 'status', value: t.pic.status, order: 0 },
                { key: 'createTime', value: t.pic.createTime, order: 0 },
            ],
            clickedIcon: '',
            visible: false,
            // 入力条件
            formItem: {
                name: '',
                status: '',
                createTime: '',
                createStartTime: '',
                createEndTime: '',
                oa: '',
                od: '',
                current: 1,
                size: 10,
            },
            createStartTimeOption: {},
            createEndTimeOption: {},
            selectIds: [],
            data: [],
            total: 0,
            // table定义列
            columns: [
                { title: '', type: 'selection', align: 'center', width: 44 },
                { title: t.table.id, key: 'id', align: 'center', width: 164 },
                { title: t.table.name, key: 'name', tooltip: true, render: renderName },
                {
                    title: t.table.thumb,
                    key: 'image',
                    align: 'center',
                    width: 100,
                    render: renderIcon,
                },
                { title: t.table.hits, key: 'hits', align: 'center', width: 110 },
                { title: t.table.sortOrder, key: 'sortOrder', align: 'center', width: 80, render: renderSortOrder },
                { title: t.table.createBy, key: 'createBy', tooltip: true },
                { title: t.table.createTime, key: 'createTime', width: 150 },
                {
                    title: t.table.status,
                    key: 'status',
                    align: 'center',
                    width: 100,
                    render: renderStatus,
                },
                {
                    title: msgUtil.message.action.name,
                    key: 'action',
                    align: 'center',
                    width: 130,
                    fixed: 'right',
                    render: renderAction,
                },
            ],
            loading: false,
        };
    },
    methods: {
        async orderClick(btn) {
            this.formItem.oa = '';
            this.formItem.od = '';
            if (btn.order === 1) {
                this.formItem.oa = btn.key;
            } else if (btn.order === 2) {
                this.formItem.od = btn.key;
            }
            await this.search(true);
        },

        //数据检索
        async search(flg) {
            if (flg) {
                this.formItem.current = 1;
                this.$refs.page.currentPage = 1;
            }
            //加载圈表示
            this.loading = true;
            await this.getCreateTime();
            //console.log(this.formItem);
            let picDto = {};
            picDto.name = this.formItem.name;
            picDto.status = this.formItem.status;
            picDto.createTime = this.formItem.createTime;
            picDto.oa = this.formItem.oa;
            picDto.od = this.formItem.od;
            picDto.current = this.formItem.current;
            picDto.size = this.formItem.size;

            const result = await getList(picDto);
            //console.log(result);
            if (result) {
                this.data = result.page.records;
                this.total = result.page.total;
            }
            this.loading = false;
        },
        //创建时间作成
        async getCreateTime() {
            this.formItem.createTime = '';
            if (this.formItem.createStartTime !== '' && this.formItem.createStartTime !== undefined) {
                this.formItem.createTime = this.formItem.createStartTime + ',';
            }
            if (this.formItem.createEndTime !== '' && this.formItem.createEndTime !== undefined) {
                if (this.formItem.createStartTime === '' || this.formItem.createStartTime === undefined) {
                    this.formItem.createTime = ',';
                }
                this.formItem.createTime += this.formItem.createEndTime;
            }
        },
        handleModal(icon) {
            this.clickedIcon = icon;
            this.visible = true;
        },
        // 页号改变
        async pageChange() {
            this.formItem.current = this.$refs.page.currentPage;
            await this.search(false);
        },
        // 每页显示数据
        async pageSizeChange() {
            this.formItem.size = this.$refs.page.currentPageSize;
            await this.search(false);
        },
        // 删除
        async del(id) {
            await del(id);
            await this.search(true);
        },
        // 批量删除
        async delAll() {
            if (this.selectIds.length === 0) {
                Message.error({
                    content: this.msgUtil.message.warn.notSelectedRow,
                    duration: 60,
                    closable: true,
                });
                return;
            }
            await delAll(this.selectIds);
            await this.search(true);
        },
        // 行选择
        rowSelect(selection) {
            this.selectIds = selection.map(p => {
                return { id: p.id };
            });
        },
        /**
         * 开始时间发生变化时触发,设置结束时间不可选择的日期
         * 结束时间应大于等于开始时间,且小于等于当前时间
         * @param {string} startTime 格式化后的日期
         * @param {string} type 当前的日期类型
         */
        onStartTimeChange(startTime) {
            this.formItem.createStartTime = startTime;
            this.createEndTimeOption = {
                disabledDate(endTime) {
                    return endTime < new Date(startTime) || endTime > Date.now();
                },
            };
        },
        /**
         * 结束时间发生变化时触发,设置开始时间不可选择的日期
         * 开始时间小于等于结束时间,且小于等于当前时间
         * @param {string} date 格式化后的日期
         * @param {string} type 当前的日期类型
         */
        onEndTimeChange(endTime) {
            this.formItem.createEndTime = endTime;
            this.createStartTimeOption = {
                disabledDate(startTime) {
                    return startTime > new Date(endTime) || startTime > Date.now();
                },
            };
        },
    },
    async mounted() {
        await this.search(true);
    },
};
</script>

<style lang="less" scoped>
.pic-upload-list {
    display: inline-block;
    text-align: center;
    line-height: 0px;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
    img {
        width: 200px;
        height: 200px;
    }
}

.pic-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}

.pic-upload-list:hover .pic-upload-list-cover {
    display: block;
}

.pic-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>
